import GustoLogoPNG from 'assets/img/gusto-logo.png';

const constants = {
    oauthPresentation: {
        gusto: {
            image: GustoLogoPNG,
            imageHeight: '24',
            text: 'Linking Gusto to your Collective Dashboard will automatically sync your payroll data to set your business up for success by maximizing your tax savings, providing direct insights to set your business up for success, and more!',
            modalTitle: 'Disconnect Gusto',
            modalMessage:
                'If you disconnect your Gusto account, Collective will no longer be able to access the reports we need to calculate your taxes. <b>Are you sure you want to continue?</b>',
        },
        hurdlr: {
            image: GustoLogoPNG,
            imageHeight: '24',
            text: '',
            modalTitle: '',
            modalMessage: '',
        },
    },
};
export default constants;
